import { AlertCircle } from "lucide-react";

export default function TransactionProgress({ step, currentTransaction }) {
  // Don't show progress on step 3 (summary step)
  if (step === 3) return null;

  const getStepStatus = (stepNumber) => {
    if (step > stepNumber) return 'completed';
    if (step === stepNumber) return 'current';
    return 'pending';
  };

  const getStepConfig = (stepNumber, status) => {
    if (status === 'completed') {
      return {
        bgColor: 'bg-green-500 text-white',
        textColor: 'text-gray-900 font-medium',
        icon: '✓',
        label: 'Completed'
      };
    }
    if (status === 'current') {
      return {
        bgColor: 'bg-blue-500 text-white',
        textColor: 'text-gray-900 font-medium',
        icon: stepNumber.toString(),
        label: 'In Progress'
      };
    }
    return {
      bgColor: 'bg-gray-300 text-gray-600',
      textColor: 'text-gray-600',
      icon: stepNumber.toString(),
      label: null
    };
  };

  const steps = [
    { number: 1, title: 'Find Customer & Enter Amount' },
    { number: 2, title: 'Review and Complete Transaction' }
  ];

  // Special handling for step 2 completion
  const step2Status = step >= 2 ? (
    (currentTransaction?.status === 'FULFILLED' || currentTransaction?.status === 'CANCELLED') 
      ? 'completed' 
      : 'current'
  ) : 'pending';

  return (
    <div className="theme-card rounded-lg p-4 md:p-6">
      <div className="flex items-start space-x-3">
        <div className="bg-blue-100 p-2 rounded-lg flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-blue-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900 mb-3">Transaction Progress</h3>
          <div className="space-y-3">
            {steps.map((stepItem) => {
              const status = stepItem.number === 2 ? step2Status : getStepStatus(stepItem.number);
              const config = getStepConfig(stepItem.number, status);
              
              return (
                <div key={stepItem.number} className="flex items-center space-x-3">
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-semibold ${config.bgColor}`}>
                    {config.icon}
                  </div>
                  <span className={`text-sm ${config.textColor}`}>
                    {stepItem.title}
                  </span>
                  {config.label && (
                    <span className={`text-xs font-medium ${
                      config.label === 'Completed' ? 'text-green-600' : 'text-blue-600'
                    }`}>
                      {config.label}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}